import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { OidcConfigurationComponent } from './oidc-configuration/oidc-configuration'
import { GroupMappingOidc } from './group-mapping-oidc/group-mapping-oidc.component';
import { OidcComponent } from './oidc.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        OidcConfigurationComponent,
        GroupMappingOidc,
        OidcComponent
    ],
    entryComponents: [OidcComponent],
    exports: [OidcComponent]
})
export class OidcModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/oidc-configuration/oidc.module.ts